// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-invoice-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
}
@media (max-width: 768px) {
  .system-invoice-form-container {
    padding: 1rem;
  }
}
.system-invoice-form-container .no-spinner::-webkit-outer-spin-button,
.system-invoice-form-container .no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.system-invoice-form-container .system-invoice-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .system-invoice-form-container .system-invoice-form-wrapper {
    padding: 1rem;
    width: 95%;
  }
}
.system-invoice-form-container .system-invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.system-invoice-form-container .system-invoice-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0.5rem;
}
.system-invoice-form-container .system-invoice-form-header .system-invoice-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .system-invoice-form-container .system-invoice-form-header .system-invoice-form-title {
    font-size: 1.25rem;
  }
}
.system-invoice-form-container .system-invoice-form-header .company-name {
  font-size: 0.95rem;
  color: #6b7280;
  margin-top: 0.5rem;
}
.system-invoice-form-container .system-invoice-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.system-invoice-form-container .system-invoice-form-content {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
}
.system-invoice-form-container .form-section {
  background: transparent;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
}
.system-invoice-form-container .form-section:last-of-type {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .system-invoice-form-container .form-section {
    padding: 1rem;
  }
}
.system-invoice-form-container .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .system-invoice-form-container .form-section h3 {
    font-size: 0.95rem;
  }
}
.system-invoice-form-container .form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .system-invoice-form-container .form-row {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}
.system-invoice-form-container .form-group {
  display: flex;
  flex-direction: column;
}
.system-invoice-form-container .form-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}
.system-invoice-form-container .form-group input,
.system-invoice-form-container .form-group select,
.system-invoice-form-container .form-group textarea {
  padding: 0.625rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: all 0.2s;
}
.system-invoice-form-container .form-group input:focus,
.system-invoice-form-container .form-group select:focus,
.system-invoice-form-container .form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.system-invoice-form-container .form-group input:disabled,
.system-invoice-form-container .form-group select:disabled,
.system-invoice-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}
.system-invoice-form-container .form-group .readonly-input {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.system-invoice-form-container .form-group .amount-display {
  padding: 0.625rem;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  display: flex;
  align-items: center;
}
.system-invoice-form-container .summary {
  background-color: #f9fafb;
  padding: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
}
.system-invoice-form-container .summary p {
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
  font-size: 0.875rem;
  color: #374151;
}
.system-invoice-form-container .summary p.total-amount {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  padding-top: 0.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid #d1d5db;
}
.system-invoice-form-container .summary p strong {
  font-weight: 500;
}
.system-invoice-form-container .form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .system-invoice-form-container .form-actions {
    flex-direction: column;
  }
}
.system-invoice-form-container .form-actions button {
  padding: 0.625rem 1.25rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}
.system-invoice-form-container .form-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .system-invoice-form-container .form-actions button {
    width: 100%;
    padding: 0.75rem;
  }
}
.system-invoice-form-container .form-actions .btn-primary {
  background-color: #3b82f6;
  color: white;
}
.system-invoice-form-container .form-actions .btn-primary:hover:not(:disabled) {
  background-color: #2563eb;
}
.system-invoice-form-container .form-actions .btn-secondary {
  background-color: #6b7280;
  color: white;
}
.system-invoice-form-container .form-actions .btn-secondary:hover:not(:disabled) {
  background-color: #4b5563;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/SystemInvoiceForm/SystemInvoiceForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EAXF;IAYI,aAAA;EACF;AACF;AACE;;EAEE,wBAAA;EACA,SAAA;AACJ;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,gCAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,UAAA;EACJ;AACF;AAEE;EACE,cAAA;EACA,oBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAGI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AADN;AAKE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAHJ;AAME;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AAJJ;AAOE;EACE,uBAAA;EACA,uBAAA;EACA,qBAAA;AALJ;AAOI;EACE,gBAAA;AALN;AAQI;EATF;IAUI,aAAA;EALJ;AACF;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AALN;AAOM;EARF;IASI,kBAAA;EAJN;AACF;AAQE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AANJ;AAQI;EANF;IAOI,0BAAA;IACA,YAAA;EALJ;AACF;AAQE;EACE,aAAA;EACA,sBAAA;AANJ;AAQI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AANN;AASI;;;EAGE,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAPN;AASM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AALR;AAQM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAJR;AAQI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AANN;AASI;EACE,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAPN;AAWE;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;AATJ;AAWI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AATN;AAWM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AATR;AAYM;EACE,gBAAA;AAVR;AAeE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AAbJ;AAeI;EARF;IASI,sBAAA;EAZJ;AACF;AAcI;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AAZN;AAcM;EACE,YAAA;EACA,mBAAA;AAZR;AAeM;EAdF;IAeI,WAAA;IACA,gBAAA;EAZN;AACF;AAeI;EACE,yBAAA;EACA,YAAA;AAbN;AAeM;EACE,yBAAA;AAbR;AAiBI;EACE,yBAAA;EACA,YAAA;AAfN;AAiBM;EACE,yBAAA;AAfR;;AAqBA;EACE;IACE,UAAA;IACA,4BAAA;EAlBF;EAoBA;IACE,UAAA;IACA,wBAAA;EAlBF;AACF","sourcesContent":["// System Invoice Form Styles\n.system-invoice-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  .no-spinner::-webkit-outer-spin-button,\n  .no-spinner::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .system-invoice-form-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    animation: fade-in 0.3s ease-out;\n    width: 70%;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      width: 95%;\n    }\n  }\n\n  .system-invoice-form-required {\n    color: #ef4444;\n    margin-left: 0.25rem;\n  }\n\n  .system-invoice-form-header {\n    position: relative;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    .system-invoice-form-title {\n      font-size: 1.3rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n\n    .company-name {\n      font-size: 0.95rem;\n      color: #6b7280;\n      margin-top: 0.5rem;\n    }\n  }\n\n  .system-invoice-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  .system-invoice-form-content {\n    padding: 0;\n    margin: 0;\n    border: none;\n    background: transparent;\n  }\n\n  .form-section {\n    background: transparent;\n    border-radius: 0.375rem;\n    margin-bottom: 1.5rem;\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n    }\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n\n      @media (max-width: 768px) {\n        font-size: 0.95rem;\n      }\n    }\n  }\n\n  .form-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n      gap: 0.75rem;\n    }\n  }\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n    label {\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: #374151;\n      margin-bottom: 0.5rem;\n    }\n\n    input,\n    select,\n    textarea {\n      padding: 0.625rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.375rem;\n      font-size: 0.875rem;\n      transition: all 0.2s;\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:disabled {\n        background-color: #f9fafb;\n        color: #9ca3af;\n        cursor: not-allowed;\n      }\n    }\n\n    .readonly-input {\n      background-color: #f9fafb;\n      color: #6b7280;\n      cursor: not-allowed;\n    }\n\n    .amount-display {\n      padding: 0.625rem;\n      background-color: #f3f4f6;\n      border: 1px solid #e5e7eb;\n      border-radius: 0.375rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: #374151;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .summary {\n    background-color: #f9fafb;\n    padding: 1rem;\n    border-radius: 0.375rem;\n    border: 1px solid #e5e7eb;\n\n    p {\n      display: flex;\n      justify-content: space-between;\n      margin: 0.5rem 0;\n      font-size: 0.875rem;\n      color: #374151;\n\n      &.total-amount {\n        font-size: 1rem;\n        font-weight: 600;\n        color: #111827;\n        padding-top: 0.5rem;\n        margin-top: 0.5rem;\n        border-top: 1px solid #d1d5db;\n      }\n\n      strong {\n        font-weight: 500;\n      }\n    }\n  }\n\n  .form-actions {\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n    margin-top: 1.5rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    button {\n      padding: 0.625rem 1.25rem;\n      border-radius: 0.375rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s;\n      border: none;\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      @media (max-width: 768px) {\n        width: 100%;\n        padding: 0.75rem;\n      }\n    }\n\n    .btn-primary {\n      background-color: #3b82f6;\n      color: white;\n\n      &:hover:not(:disabled) {\n        background-color: #2563eb;\n      }\n    }\n\n    .btn-secondary {\n      background-color: #6b7280;\n      color: white;\n\n      &:hover:not(:disabled) {\n        background-color: #4b5563;\n      }\n    }\n  }\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
